//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'ImageFilePreview',
  props: {
    file: {
      type: [Object, File],
      required: true
    },
    showBtnShow: {
      type: Boolean,
      default: false
    },
    showBtnRemove: {
      type: Boolean,
      default: false
    },
    fixRemoveBtn: {
      type: Boolean,
      default: true
    },
    showBtnMarker: {
      type: Object,
      default: null
    },
    sizeImg: {
      type: Number,
      default: 140
    },
    showIndex: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    askDeleteConfirmation: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      showDialogOnRemoved: false,
      thumbnailLoadAllowed: false
      // intersectionObserver: null - не реактивное
    }
  },
  computed: {
    cssClass: function () {
      let cssClass = '_file-id-'
      if (this.file && this.file.document && this.file.document.id != null) {
        cssClass += this.file.document.id
      } else {
        cssClass += '-'
      }

      if (this.file && this.file.document && this.file.document._key != null) {
        cssClass += this.file.document._key
      }

      return cssClass
    },
    url: function () {
      if (this.file.isToUpload) {
        return this.file.file.thumb
      } else {
        return this.file.smallBlob //  || this.file.smallUrl
      }
    },
    containerStyle: function () {
      if (this.file.uploadError) {
        return 'background-color: #e53935' // red-7
      } else if (this.file.props && this.file.props.warnings && this.file.props.warnings.length) {
        return 'background-color: #f2c037;' // warning
      } else if (this.file.selected) {
        return 'background-color: #1E90FF;'
      }
      return ''
    },
    showBtnRemoveLocal: function () {
      return (this.showBtnRemove && (!this.file.props || !this.file.props.readonly)) || this.file.isToUpload
    },
    classBtnMarker: function () {
      // TODO refactor - перенести кастомную логику в SLOT
      return this.showBtnMarker && this.file.document && this.file.document[this.showBtnMarker.property] !== undefined && this.file.document[this.showBtnMarker.property]
    }
  },
  watch: {
    file: {
      handler: function (file) {
        this.$nextTick(() => {
          this.setSizeImg()
        })
        this.loadThumbnail()
      },
      immediate: true
    }
  },
  updated: function () {
    this.$nextTick(() => {
      this.setSizeImg()
    })
  },
  mounted: function () {
    if (!window.IntersectionObserver) {
      this.loadThumbnail(true)
    } else {
      this.intersectionObserver = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.destroyIntersectionObserver()
            this.loadThumbnail(true)
            break
          }
        }
      })
      this.intersectionObserver.observe(this.$el)
    }
  },
  beforeDestroy: function () {
    this.destroyIntersectionObserver()
  },
  methods: {
    loadThumbnail: function (thumbnailLoadAllowed) {
      if (thumbnailLoadAllowed) {
        this.thumbnailLoadAllowed = thumbnailLoadAllowed
      }

      if (this.thumbnailLoadAllowed) {
        const file = this.file
        if (file && !file.isToUpload && !file.smallBlob) {
          file.loadThumbnail()
        }
      }
    },
    destroyIntersectionObserver: function () {
      if (this.intersectionObserver) {
        const el = this.$el
        if (el) {
          this.intersectionObserver.unobserve(el)
        }
        this.intersectionObserver.disconnect()
        this.intersectionObserver = null
      }
    },
    setSizeImg: function () {
      const documentImgs = [...document.getElementsByClassName(this.cssClass)]
      const size = this.sizeImg

      documentImgs.forEach(documentImg => {
        if (documentImg) {
          documentImg.style.setProperty('--size-img', size)
        }
      })
    },
    onClick: function (event) {
      this.$emit('click', event)
    },
    onRemove: function (event) {
      this.$emit('delete', event)
    },
    onAskRemove: function (file) {
      if (this.askDeleteConfirmation) {
        this.$d_ask({
          callback: (data, action) => {
            if (action === 'yes') {
              this.onRemove(file)
            }
          },
          warning: 'Удалить «' + file.name + '» ?\n',
          buttons: [
            { key: 'yes', name: 'Да', color: 'red' },
            { key: 'no', name: 'Отмена', color: 'white' }
          ]
        })
      } else {
        this.onRemove(file)
      }
    }
  }
}
